export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      about: "À propos",
      ministries: "Ministères",
      events: "Événements",
      media: "Enseignements",
      impact: "Impact International",
      churches: "Églises",
      partnership: "Partenariat",
      prayer: "Demande de prière",
      books: "Livres",
      member: "Devenir membre",
      contact: "Contact",
      donate: "Faire un don",
    },
    cta: {
      donate: "Faire un don",
      becomeMember: "Devenir membre",
      discoverVision: "Découvrir la vision",
      learnMore: "En savoir plus",
      readMore: "Lire la suite",
      seeAll: "Voir tout",
      register: "S'inscrire",
      submit: "Envoyer",
      watch: "Regarder",
    },
    home: {
      heroEyebrow: "Dalo Ministries International",
      heroTitle: "Connecter les cœurs\nà l'amour de Dieu.",
      heroSub:
        "Un ministère international fondé sur la foi, l'excellence et la transformation des vies à travers les nations.",
      aboutEyebrow: "Notre histoire",
      aboutTitle: "Un ministère né d'un appel,\nporté par une vision globale.",
      aboutBody:
        "Pasteur Roland Dalo conduit Dalo Ministries International, un mouvement spirituel international qui rassemble des hommes et des femmes de toutes nations autour d'une mission commune : voir le Royaume de Dieu s'établir avec puissance et grâce dans chaque sphère de la société.",
      impactEyebrow: "Présence mondiale",
      impactTitle: "Un message. Une mission.\nDes nations transformées.",
      impactSub:
        "De Paris à Abidjan, de Londres à Kinshasa, le ministère touche des dizaines de milliers de vies chaque année à travers conférences, missions et plateformes médias.",
      videosEyebrow: "Derniers messages",
      videosTitle: "Enseignements qui transforment.",
      eventsEyebrow: "Agenda",
      eventsTitle: "Rendez-vous prophétiques.",
      testimoniesEyebrow: "Témoignages",
      testimoniesTitle: "Des vies restaurées,\ndes destinées révélées.",
      donateEyebrow: "Partenariat",
      donateTitle: "Soyez la main\nqui change une nation.",
      donateBody:
        "Chaque partenaire, chaque don, chaque prière contribue à étendre l'impact du Royaume sur les nations.",
    },
    stats: {
      years: "Années de ministère",
      countries: "Nations touchées",
      conferences: "Conférences organisées",
      community: "Communauté mondiale",
    },

    books: {
      eyebrow: "Librairie",
      title: "Les livres de l'Apôtre Roland Dalo",
      subtitle:
        "Découvrez les ouvrages de l'Apôtre Roland Dalo, des ressources destinées à approfondir votre connaissance de Dieu et à accompagner votre croissance spirituelle.",
    },

    footer: {
      tagline: "Un ministère. Une vision. Des nations.",
      explore: "Explorer",
      resources: "Ressources",
      connect: "Se connecter",
      newsletter: "Recevez nos derniers messages",
      newsletterPh: "Votre adresse email",
      subscribe: "S'abonner",
      rights: "Tous droits réservés.",
      legal: "Mentions légales",
      privacy: "Confidentialité",
    },
    about: {
      eyebrow: "À propos",
      title: "Roland Dalo —\nl'homme, le message, le mandat.",
      bioTitle: "Biographie",
      bioBody:
        "Pasteur, enseignant, conférencier international, Roland Dalo est connu pour la profondeur de son enseignement et la clarté prophétique de sa parole. Depuis plus de deux décennies, il forme des leaders, plante des œuvres et inspire toute une génération à embrasser le plan de Dieu pour leur vie.",
      timelineTitle: "Une vie. Un appel. Un héritage.",
      visionTitle: "Notre vision",
      visionBody:
        "Voir une génération de croyants ancrés dans la Parole, marchant dans l'autorité du Royaume et impactant chaque sphère de la société.",
      missionTitle: "Notre mission",
      missionBody:
        "Former, équiper et envoyer des disciples authentiques à travers les nations par l'enseignement, la prière et le mentorat.",
      legacyQuote:
        "Une génération qui comprend ses temps changera le cours d'une nation.",
    },
    ministries: {
      eyebrow: "Nos ministères",
      title: "Sept piliers.\nUne vision unifiée.",
      sub: "Chaque département du ministère sert un appel particulier : enseigner, servir, équiper, déployer.",
    },
    events: {
      eyebrow: "Événements",
      title: "Un calendrier de moments\nqui changent des vies.",
      upcoming: "À venir",
      filterAll: "Tous",
      filterConf: "Conférences",
      filterCamp: "Campagnes",
      filterRetreat: "Retraites",
    },
    media: {
      eyebrow: "Bibliothèque",
      title: "Messages, podcasts, archives.",
      filterAll: "Tout",
      filterSermons: "Prédications",
      filterTeach: "Enseignements",
      filterPodcasts: "Podcasts",
      filterInterviews: "Interviews",
    },
    impactPage: {
      eyebrow: "Impact International",
      title: "Le Royaume\nn'a pas de frontières.",
      sub: "Une cartographie vivante de la présence de DMI à travers les continents.",
    },
    churches: {
      eyebrow: "Nos églises",
      title: "Une famille spirituelle\nrépartie sur trois continents.",
      visit: "Visiter l'église",
    },
    partnership: {
      eyebrow: "Partenariat & Don",
      title: "Donner. Servir. Étendre le Royaume.",
      sub: "Choisissez la façon dont vous souhaitez devenir partenaire du ministère.",
      oneTime: "Don unique",
      monthly: "Partenaire mensuel",
      legacy: "Partenaire d'héritage",
    },
    prayer: {
      eyebrow: "Prière",
      title: "Nous prions avec vous.",
      sub: "Soumettez votre requête en toute confidentialité. Notre équipe de prière intercède 7 jours sur 7.",
      name: "Nom complet",
      email: "Email",
      country: "Pays",
      request: "Votre requête",
      sent: "Votre requête a été reçue. Nous prions avec vous.",
    },
    member: {
      eyebrow: "Membre",
      title: "Rejoignez la famille DMI.",
      sub: "Trois étapes pour rejoindre officiellement la communauté.",
      step1: "Identité",
      step2: "Parcours spirituel",
      step3: "Engagement",
      done: "Bienvenue dans la famille. Nous reviendrons vers vous très bientôt.",
    },
    contact: {
      eyebrow: "Contact",
      title: "Parlons. Nous écoutons.",
      sub: "Pour toute demande pastorale, médias ou partenariat, écrivez-nous.",
      name: "Nom complet",
      email: "Email",
      subject: "Sujet",
      message: "Message",
      sent: "Message envoyé. Merci de nous avoir contactés.",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      ministries: "Ministries",
      events: "Events",
      media: "Media",
      impact: "International Impact",
      churches: "Churches",
      partnership: "Partnership",
      prayer: "Prayer Request",
      member: "Become a Member",
      contact: "Contact",
      donate: "Donate",
    },
    cta: {
      donate: "Donate",
      becomeMember: "Become a Member",
      discoverVision: "Discover the Vision",
      learnMore: "Learn more",
      readMore: "Read more",
      seeAll: "See all",
      register: "Register",
      submit: "Submit",
      watch: "Watch",
    },
    home: {
      heroEyebrow: "Dalo Ministries International",
      heroTitle: "Connecting hearts\nto the love of God.",
      heroSub:
        "An international ministry rooted in faith, excellence, and the transformation of lives across nations.",
      aboutEyebrow: "Our story",
      aboutTitle: "A ministry born from a calling,\ncarried by a global vision.",
      aboutBody:
        "Pastor Roland Dalo leads Dalo Ministries International — a global spiritual movement gathering men and women from every nation around one mission: to see the Kingdom of God established with power and grace in every sphere of society.",
      impactEyebrow: "Global presence",
      impactTitle: "One message. One mission.\nNations transformed.",
      impactSub:
        "From Paris to Abidjan, from London to Kinshasa, the ministry reaches tens of thousands of lives every year through conferences, missions, and media platforms.",
      videosEyebrow: "Latest messages",
      videosTitle: "Teachings that transform.",
      eventsEyebrow: "Calendar",
      eventsTitle: "Prophetic appointments.",
      testimoniesEyebrow: "Testimonies",
      testimoniesTitle: "Restored lives,\nrevealed destinies.",
      donateEyebrow: "Partnership",
      donateTitle: "Be the hand\nthat shapes a nation.",
      donateBody:
        "Every partner, every gift, every prayer extends the Kingdom's reach across the world.",
    },
    stats: {
      years: "Years of ministry",
      countries: "Nations reached",
      conferences: "Conferences held",
      community: "Global community",
    },
    footer: {
      tagline: "One ministry. One vision. Many nations.",
      explore: "Explore",
      resources: "Resources",
      connect: "Connect",
      newsletter: "Receive our latest messages",
      newsletterPh: "Your email address",
      subscribe: "Subscribe",
      rights: "All rights reserved.",
      legal: "Legal notice",
      privacy: "Privacy",
    },
    about: {
      eyebrow: "About",
      title: "Roland Dalo —\nthe man, the message, the mandate.",
      bioTitle: "Biography",
      bioBody:
        "Pastor, teacher, international speaker, Roland Dalo is known for the depth of his teaching and the prophetic clarity of his word. For over two decades, he has been raising leaders, planting works, and inspiring an entire generation to embrace God's plan for their lives.",
      timelineTitle: "A life. A calling. A legacy.",
      visionTitle: "Our vision",
      visionBody:
        "To see a generation of believers grounded in the Word, walking in Kingdom authority, and impacting every sphere of society.",
      missionTitle: "Our mission",
      missionBody:
        "To train, equip, and send authentic disciples across nations through teaching, prayer, and mentorship.",
      legacyQuote:
        "A generation that understands its times will change the course of a nation.",
    },
    ministries: {
      eyebrow: "Our ministries",
      title: "Seven pillars.\nOne unified vision.",
      sub: "Each department of the ministry serves a specific calling: to teach, to serve, to equip, to send.",
    },
    events: {
      eyebrow: "Events",
      title: "A calendar of moments\nthat change lives.",
      upcoming: "Upcoming",
      filterAll: "All",
      filterConf: "Conferences",
      filterCamp: "Campaigns",
      filterRetreat: "Retreats",
    },
    books: {
        eyebrow: "Bookstore",
        title: "Books by Apostle Roland Dalo",
        subtitle:
          "Discover Apostle Roland Dalo's books, resources designed to deepen your knowledge of God and support your spiritual growth.",
      },
    media: {
      eyebrow: "Library",
      title: "Messages, podcasts, archives.",
      filterAll: "All",
      filterSermons: "Sermons",
      filterTeach: "Teachings",
      filterPodcasts: "Podcasts",
      filterInterviews: "Interviews",
    },
    impactPage: {
      eyebrow: "International Impact",
      title: "The Kingdom\nhas no borders.",
      sub: "A living map of DMI's presence across continents.",
    },
    churches: {
      eyebrow: "Our churches",
      title: "One spiritual family\nspread across three continents.",
      visit: "Visit church",
    },
    partnership: {
      eyebrow: "Partnership & Giving",
      title: "Give. Serve. Extend the Kingdom.",
      sub: "Choose how you would like to partner with the ministry.",
      oneTime: "One-time gift",
      monthly: "Monthly partner",
      legacy: "Legacy partner",
    },
    prayer: {
      eyebrow: "Prayer",
      title: "We pray with you.",
      sub: "Submit your request in full confidence. Our prayer team intercedes 7 days a week.",
      name: "Full name",
      email: "Email",
      country: "Country",
      request: "Your request",
      sent: "Your request has been received. We're praying with you.",
    },
    member: {
      eyebrow: "Member",
      title: "Join the DMI family.",
      sub: "Three simple steps to officially join the community.",
      step1: "Identity",
      step2: "Spiritual journey",
      step3: "Commitment",
      done: "Welcome to the family. We'll be in touch very soon.",
    },
    contact: {
      eyebrow: "Contact",
      title: "Let's talk. We're listening.",
      sub: "For any pastoral, media, or partnership inquiry, write to us.",
      name: "Full name",
      email: "Email",
      subject: "Subject",
      message: "Message",
      sent: "Message sent. Thank you for reaching out.",
    },
  },
};
